/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

/**
 * The TableStiffener component
 *
 * @author Thais Watanabe
 */
const TableStiffener = (props) => {
  const {
    turbineInspection,
    openEdit,
    openObs,
    inspection,
    i11,
    r11_4,
    r11_5,
    r11_6,
  } = props;

  return (
    <div className="flex flex-col gap-4 print:gap-2">
      <Table>
        <thead>
          <tr>
            <ColHeader className="text-center print:hidden" rowSpan={3}></ColHeader>
            <ColHeader className="text-center" rowSpan={3}>
              軸
            </ColHeader>
            <ColHeader className="text-center" colSpan={9}>
              メインスティフナー
            </ColHeader>
          </tr>
          <tr>
            <ColHeader className="text-center" colSpan={3}>
              円弧部
            </ColHeader>
            <ColHeader className="text-center" colSpan={3}>
              PS接合部
            </ColHeader>
            <ColHeader className="text-center" colSpan={3}>
              SS接合部
            </ColHeader>
          </tr>
          <tr>
            <ColHeader className="text-center">正面</ColHeader>
            <ColHeader className="text-center">LE側</ColHeader>
            <ColHeader className="text-center">TE側</ColHeader>
            <ColHeader className="text-center">LE側</ColHeader>
            <ColHeader className="text-center">TE側</ColHeader>
            <ColHeader className="text-center">根元側</ColHeader>
            <ColHeader className="text-center">LE側</ColHeader>
            <ColHeader className="text-center">TE側</ColHeader>
            <ColHeader className="text-center">根元側</ColHeader>
          </tr>
        </thead>
        <TableBody>
          {/* 1 */}
          <tr>
            <Col className="text-center print:hidden">
              <ResultDropdown
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i11}
                turbineInspection={turbineInspection}
                selectedResult={r11_4}
                inspection={inspection}
              />
            </Col>
            <Col className="text-center">1</Col>
            {[...Array(9)].map((x, i) => (
              <Col className="text-center" key={i}>
                <ResultBadge
                  result={r11_4?.childrenResults[i] ?? "-"}
                  unit={i11?.inspectionModelItemChildren.items?.[i].unit}
                  isInputCorrect={isInputCorrect(
                    i11?.name,
                    r11_4?.childrenResults[i] ?? "-",
                    i
                  )}
                />
              </Col>
            ))}
          </tr>
          {/* 2 */}
          <tr>
            <Col className="text-center print:hidden">
              <ResultDropdown
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i11}
                turbineInspection={turbineInspection}
                selectedResult={r11_5}
                inspection={inspection}
              />
            </Col>
            <Col className="text-center">2</Col>
            {[...Array(9)].map((x, i) => (
              <Col className="text-center" key={i}>
                <ResultBadge
                  result={r11_5?.childrenResults[i] ?? "-"}
                  unit={i11?.inspectionModelItemChildren.items?.[i].unit}
                  isInputCorrect={isInputCorrect(
                    i11?.name,
                    r11_5?.childrenResults[i] ?? "-",
                    i
                  )}
                />
              </Col>
            ))}
          </tr>
          {/* 3 */}
          <tr>
            <Col className="text-center print:hidden">
              <ResultDropdown
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i11}
                turbineInspection={turbineInspection}
                selectedResult={r11_6}
                inspection={inspection}
              />
            </Col>
            <Col className="text-center">3</Col>
            {[...Array(9)].map((x, i) => (
              <Col className="text-center" key={i}>
                <ResultBadge
                  result={r11_6?.childrenResults[i] ?? "-"}
                  unit={i11?.inspectionModelItemChildren.items?.[i].unit}
                  isInputCorrect={isInputCorrect(
                    i11?.name,
                    r11_6?.childrenResults[i] ?? "-",
                    i
                  )}
                />
              </Col>
            ))}
          </tr>
        </TableBody>
      </Table>

      <Table>
        <thead>
          <tr>
            <ColHeader
              className="text-center print:hidden"
              rowSpan={3}
            ></ColHeader>
            <ColHeader className="text-center" rowSpan={3}>
              軸
            </ColHeader>
            <ColHeader className="text-center" colSpan={9}>
              セカンダリスティフナー
            </ColHeader>
          </tr>
          <tr>
            <ColHeader className="text-center" colSpan={3}>
              円弧部
            </ColHeader>
            <ColHeader className="text-center" colSpan={3}>
              PS接合部
            </ColHeader>
            <ColHeader className="text-center" colSpan={3}>
              SS接合部
            </ColHeader>
          </tr>
          <tr>
            <ColHeader className="text-center">正面</ColHeader>
            <ColHeader className="text-center">LE側</ColHeader>
            <ColHeader className="text-center">TE側</ColHeader>
            <ColHeader className="text-center">LE側</ColHeader>
            <ColHeader className="text-center">TE側</ColHeader>
            <ColHeader className="text-center">根元側</ColHeader>
            <ColHeader className="text-center">LE側</ColHeader>
            <ColHeader className="text-center">TE側</ColHeader>
            <ColHeader className="text-center">根元側</ColHeader>
          </tr>
        </thead>
        <TableBody>
          {/* 1 */}
          <tr>
            <Col className="text-center print:hidden">
              <ResultDropdown
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i11}
                turbineInspection={turbineInspection}
                selectedResult={r11_4}
                inspection={inspection}
              />
            </Col>
            <Col className="text-center">1</Col>
            {[...Array(9)].map((x, i) => (
              <Col className="text-center" key={i}>
                <ResultBadge
                  result={r11_4?.childrenResults[i + 9] ?? "-"}
                  unit={i11?.inspectionModelItemChildren.items?.[i + 9].unit}
                  isInputCorrect={isInputCorrect(
                    i11?.name,
                    r11_4?.childrenResults[i + 9] ?? "-",
                    i + 9
                  )}
                />
              </Col>
            ))}
          </tr>
          {/* 2 */}
          <tr>
            <Col className="text-center print:hidden">
              <ResultDropdown
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i11}
                turbineInspection={turbineInspection}
                selectedResult={r11_5}
                inspection={inspection}
              />
            </Col>
            <Col className="text-center">2</Col>
            {[...Array(9)].map((x, i) => (
              <Col className="text-center" key={i}>
                <ResultBadge
                  result={r11_5?.childrenResults[i] ?? "-"}
                  unit={i11?.inspectionModelItemChildren.items?.[i].unit}
                  isInputCorrect={isInputCorrect(
                    i11?.name,
                    r11_5?.childrenResults[i] ?? "-",
                    i
                  )}
                />
              </Col>
            ))}
          </tr>
          {/* 3 */}
          <tr>
            <Col className="text-center print:hidden">
              <ResultDropdown
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i11}
                turbineInspection={turbineInspection}
                selectedResult={r11_6}
                inspection={inspection}
              />
            </Col>
            <Col className="text-center">3</Col>
            {[...Array(9)].map((x, i) => (
              <Col className="text-center" key={i}>
                <ResultBadge
                  result={r11_6?.childrenResults[i] ?? "-"}
                  unit={i11?.inspectionModelItemChildren.items?.[i].unit}
                  isInputCorrect={isInputCorrect(
                    i11?.name,
                    r11_6?.childrenResults[i] ?? "-",
                    i
                  )}
                />
              </Col>
            ))}
          </tr>
        </TableBody>
      </Table>
    </div>
  );
};

export default TableStiffener;
